import React, { Component } from 'react';

class ContainerMid extends Component {
    constructor(props){
        super(props);
        this.state = {
          collMid: [
            {
              id: 1,
              subtitle: "Criteria 3",
              title:
                "Appropriateness of Created Literature for One's Given Context",
              text: "The narrative reflects Indonesian cultural realities and models empathy in ways that are developmentally and culturally relevant to young readers.",
            },
            {
              id: 2,
              subtitle: "Criteria 4",
              title: "Team Efforts in the Storytelling Production",
              text: "Each team member contributed distinct creative and technical strengths:writing, voiceover, music, and digital design, showing balanced collaboration.",
            },
          ],
        };
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collMid.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerMid;
